import React, { useMemo } from 'react'
import { Container, Button } from '@sencha/ext-modern'

import { reconfigButton } from 'tyan/public/utility'
import { getMixedProps } from './blockPublic'
import { useEventHandler } from 'tyan/public/hooks'
import { handleCommonContextMenu } from '../../column/contextmenu'

const FormButton = props => {
	const { button } = props
	const o = reconfigButton(button)
	const { icon, cdt, _button: text } = o
	const { props: { contextmenu, ...btnProps } } = getMixedProps('_button', [o])

	const handleContextMenu = useEventHandler(e => handleCommonContextMenu(contextmenu, e))

	const listeners = useMemo(() => ({
		contextmenu: {
			element: 'element',
			fn: handleContextMenu
		}
	}), [])

	// console.log('listeners:', listeners)
	return cdt && !cdt() ? null : <Button {...{ text, listeners }} {...(icon ? { iconCls: `x-fa fa-${icon}` } : {})} {...btnProps} />
}

const Buttons = ({ field, defaultStyle }) => {
	const { props: { items, ...props } } = getMixedProps('_buttons', [defaultStyle, field])
	const buttons = items || field._buttons
	if (!buttons || !buttons.find(o => o && (!o.cdt || o.cdt()))) return null
	return <Container {...props} {...{ errorTarget: undefined }}>
		{buttons.map((o, i) => <FormButton key={i} button={o} />)}
	</Container>
}

const renderButtons = config => {
	const { key } = config.field || {}
	return <Buttons key={key} {...config} />
}

export default renderButtons